import { render, staticRenderFns } from "./TableFieldCombo.vue?vue&type=template&id=c6a1f4c8"
import script from "./TableFieldCombo.vue?vue&type=script&lang=js"
export * from "./TableFieldCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports